import {
  FolderIcon,
  CalendarIcon,
  CalendarDaysIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";
import {
  BookOpenIcon,
  GraduationCap,
  UserRoundPlus,
  TicketIcon,
  Building2,
  Percent,
  Bell,
  Calendar,
} from "lucide-react";

const navigation: NavigationItem[] = [
  {
    name: "Events",
    href: "#",
    icon: Calendar,
    current: false,
    internalName: "events",
    roles: ["ROLE_SUPER_ADMIN"],
    permissions: [],
    isCertainPathOnly: true,
    children: [
      {
        name: "Event Directory",
        href: "/event-registration/events",
        icon: BookOpenIcon,
        current: false,
        internalName: "event-directory",
        roles: ["ROLE_SUPER_ADMIN"],
        permissions: [],
        isCertainPathOnly: true,
      },
    ],
  },
];

const eventRegistrationConfig = {
  sectionName: "event-registration",
  defaultRoute: "/event-registration/events",
  navigation,
};

export default eventRegistrationConfig;
